import { nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';
import { SITE_SURVEY_ANSWER_TYPE } from './SiteSurveyUtils';

export const isTaskChecked = (task) => nullSafeGetOrElse('answer', task, 'false') === 'true';

export const getAnswerItemsKey = (task) =>
	nullSafeGet('questionType', task) === SITE_SURVEY_ANSWER_TYPE.CHECKLIST
		? 'checklistAnswer'
		: 'taskListAnswer';

export const getAnswerItems = (task) => nullSafeGetOrElse(getAnswerItemsKey(task), task, []);

export const getPendingUnlinkedTaskItems = (task) =>
	getAnswerItems(task).filter(
		(ti) => !isTaskChecked(ti) && !nullSafeGet('linkedWorkOrderTaskItemId', ti)
	);

export const canCheckTask = (task, currentUser) => {
	const checkableByUser = isTaskChecked(task) ? task.answeredBy === currentUser.email : true;
	const checkableByLink = !nullSafeGet('linkedWorkOrderTaskItem.workOrderId', task);
	return checkableByUser && checkableByLink;
};
